import Flickity from 'flickity';
import { extendObj } from '../../utilities/helpers';

let resizer;
let flickity = null;
let tickerSpeed = 1.2;
let isPaused = false;
const flcktys = [];

function init() {
  const sliders = document.querySelectorAll('.c-flickity');

  if (!sliders) {
    return;
  }

  equalHeightsResizer();

  Array.from(sliders).forEach((slider) => {
    const defaultOptions = {
      cellSelector: '.c-flickity__item',
      wrapAround: true,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      selectedAttraction: 0.015,
      friction: 0.25
    };
    const userOptions = (slider.dataset.flickityOptions) ? JSON.parse(slider.dataset.flickityOptions) : {};
    const mergedOptions = extendObj(defaultOptions, userOptions);
    flickity = new Flickity(slider, mergedOptions);
    flickity.x = 0;

    update();

    slider.addEventListener('mouseenter', pause, false);
    slider.addEventListener('focusin', pause, false);
    slider.addEventListener('mouseleave', play, false);
    slider.addEventListener('focusout', play, false);

    flickity.on('dragStart', () => {
      isPaused = true;
    });

    flcktys.push(slider);
  });

  window.setTimeout(() => {
    equalHeightsInit();
  }, 500);
}

function equalHeightsInit() {
  flcktys.forEach((flckty) => {
    flckty.classList.add('flickity-equal');
  });
}

function equalHeightsResizer() {
  window.clearTimeout(resizer);
  resizer = window.setTimeout(() => {
    Flickity.prototype._createResizeClass = function () {
      this.element.classList.add('flickity-equal');
    };

    Flickity.createMethods.push('_createResizeClass');

    const resize = Flickity.prototype.resize;

    Flickity.prototype.resize = function () {
      this.element.classList.remove('flickity-equal');
      resize.call(this);
      this.element.classList.add('flickity-equal');
    };
  }, 10);
}

function update() {
  if (isPaused) return;
  if (flickity.slides) {
    flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
    flickity.selectedIndex = flickity.dragEndRestingSelect();
    flickity.updateSelectedSlide();
    flickity.settle(flickity.x);
  }
  window.requestAnimationFrame(update);
};

function pause() {
  isPaused = true;
};

function play() {
  if (isPaused) {
    isPaused = false;
    window.requestAnimationFrame(update);
  }
};

export default init;
